<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div v-if="isLoading" :class="b('loading')">
      <p>Загрузка...</p>
    </div>

    <div v-else-if="error" :class="b('error')">
      <p>Ошибка загрузки балансов</p>
    </div>

    <div v-else :class="b('table')">
      <div :class="b('table-header')">
        <div
          :class="b('column')"
          v-for="column in displayedColumns"
          :key="column.id"
        >
          <p :class="b('column-label')">
            {{ $t(column.label) }}
          </p>

          <button :class="b('column-sort')">
            <span :class="b('column-icon')" v-html="displayedSvg.sort"></span>
          </button>
        </div>
      </div>

      <div
        v-for="wallet in wallets"
        :key="wallet.id"
        :class="b('table-row', { frozen: wallet.frozen })"
      >
        <div :class="b('table-row-cell')">
          <div :class="b('table-row-currency')">
            <span
              v-if="wallet.type === 'fiat'"
              :class="[b('table-row-icon'), 'fi', `fi-${wallet.country}`]"
            ></span>

            <img
              v-else-if="wallet.type === 'crypto' && wallet.name"
              :class="b('table-row-icon', { crypto: true })"
              :src="
                require(`@/assets/images/crypto/${wallet.name.toLowerCase()}.svg`)
              "
              :alt="wallet.name"
            />

            <span :class="b('table-row-name')">{{ wallet.name }}</span>
            <span v-if="wallet.frozen" :class="b('table-row-frozen')"
              >Frozen</span
            >
          </div>
          <div :class="b('table-row-tag')">
            <span
              :class="b('table-row-type', {
              bank: (wallet.type as string) === 'fiat',
              crypto: (wallet.type as string) === 'crypto',
            })"
            >
              {{
                (wallet.type as string) === "fiat"
                  ? "Bank Account"
                  : "Crypto Account"
              }}
            </span>
          </div>
        </div>
        <div :class="b('table-row-cell')">
          {{ formatAmount(wallet.amount, wallet.precision) }}
        </div>
      </div>
    </div>
  </div>
</template>
